import { Redirect, RouteProps } from 'react-router-dom';
import React, { FC } from 'react';
import { useAtomValue } from 'jotai';
import { privateLoginStatus } from '@/state/privateAuth';
import { SentryRoute } from '@/sentry';
import routes from '@/components/private/routes';

export type AuthenticatedRouteProps = RouteProps;

/**
 * A route which redirects to the login page if the current user is logged out.
 */
const AuthenticatedRoute: FC<AuthenticatedRouteProps> = (props) => {
  const loginStatus = useAtomValue(privateLoginStatus);

  if (loginStatus === 'LOGGED_OUT') {
    return <Redirect to={routes.login} />;
  }

  return <SentryRoute {...props} />;
};

export default AuthenticatedRoute;
